import { SubAPI } from "./SubAPI"; // VoiceClipInfo is the lightweight shape embedded in list responses
// (e.g. on each project note).
export class VoiceClips extends SubAPI {
    list(props) { return this.fetcher.get("/api/voice-clips", props); }
    transcript(props) { return this.fetcher.get("/api/voice-clip/transcript", props); }
    upload(props) { return this.fetcher.postFormData("/api/voice-clip/upload", { file: props.file, projectChangeset: props.projectChangeset ? props.projectChangeset.toString() : "", projectNote: props.projectNote ? props.projectNote.toString() : "" }); }
}
